import api from '../lib/api';
import type {
  Participant,
  ParticipantFilterOptions,
  ParticipantResponse,
} from '../types/participant';

class ParticipantService {
  async getParticipants(filters: ParticipantFilterOptions = {}): Promise<ParticipantResponse> {
    const response = await api.get('/ace/participants', { params: filters });
    return response.data;
  }

  async createParticipant(data: Partial<Participant>): Promise<Participant> {
    const response = await api.post('/ace/participants', data);
    return response.data;
  }

  async updateParticipant(id: number, data: Partial<Participant>): Promise<Participant> {
    const response = await api.put(`/ace/participants/${id}`, data);
    return response.data;
  }

  async deleteParticipant(id: number): Promise<void> {
    await api.delete(`/ace/participants/${id}`);
  }
}

export default new ParticipantService();
